(() => {
  if (window.NeoniifyPreview && typeof window.NeoniifyPreview.render === "function") {
    return;
  }

  const PREVIEW_VERSION = "1";
  const FONT_HREF =
    "https://fonts.googleapis.com/css2?family=Alex+Brush&family=Allura&family=Anton&family=Audiowide&family=Bungee&family=Cinzel:wght@500&family=Comfortaa:wght@500&family=Cookie&family=Dancing+Script:wght@600&family=Fredoka:wght@500&family=Great+Vibes&family=Kalam:wght@700&family=Lobster&family=Maven+Pro:wght@600&family=Monoton&family=Montserrat:wght@700&family=Orbitron:wght@600&family=Oswald:wght@500&family=Pacifico&family=Parisienne&family=Pinyon+Script&family=Playfair+Display:wght@600&family=Quicksand:wght@600&family=Rajdhani:wght@600&family=Righteous&family=Satisfy&family=Tangerine:wght@700&family=Yellowtail&display=swap";
  const FONT_LIST = [
    { id: "passionate", name: "Passionate", family: "Great Vibes" },
    { id: "dreamy", name: "Dreamy", family: "Allura" },
    { id: "flowy", name: "Flowy", family: "Dancing Script" },
    { id: "original", name: "Original", family: "Monoton" },
    { id: "classic", name: "Classic", family: "Montserrat" },
    { id: "boujee", name: "Boujee", family: "Parisienne" },
    { id: "funky", name: "Funky", family: "Pacifico" },
    { id: "chic", name: "Chic", family: "Alex Brush" },
    { id: "delight", name: "Delight", family: "Cookie" },
    { id: "classy", name: "Classy", family: "Playfair Display" },
    { id: "romantic", name: "Romantic", family: "Tangerine" },
    { id: "robo", name: "Robo", family: "Orbitron" },
    { id: "charming", name: "Charming", family: "Satisfy" },
    { id: "quirky", name: "Quirky", family: "Fredoka" },
    { id: "stylish", name: "Stylish", family: "Pinyon Script" },
    { id: "sassy", name: "Sassy", family: "Lobster" },
    { id: "glam", name: "Glam", family: "Cinzel" },
    { id: "maya", name: "Maya Sans", family: "Maven Pro" },
    { id: "chemistry", name: "Chemistry", family: "Audiowide" },
    { id: "acoustic", name: "Acoustic", family: "Righteous" },
    { id: "sparky", name: "Sparky", family: "Yellowtail" },
    { id: "vibey", name: "Vibey", family: "Kalam" },
    { id: "lofi", name: "LoFi", family: "Quicksand" },
    { id: "dope", name: "Dope", family: "Bungee" },
    { id: "bossy", name: "Bossy", family: "Oswald" },
    { id: "iconic", name: "ICONIC", family: "Anton" },
    { id: "jolly", name: "Jolly", family: "Comfortaa" },
    { id: "modern", name: "MODERN", family: "Rajdhani" },
  ];
  const COLOR_LIST = [
    { name: "White", hex: "#ffffff" },
    { name: "Pink", hex: "#e5097f" },
    { name: "Green", hex: "#009846" },
    { name: "Blue", hex: "#0000ff" },
    { name: "Purple", hex: "#834e98" },
    { name: "Orange", hex: "#ef7b1b" },
    { name: "Ice Blue", hex: "#62bed3" },
    { name: "Warm White", hex: "#eedfc8" },
    { name: "Red", hex: "#e31e24" },
    { name: "Yellow", hex: "#ffed00" },
  ];
  const SIZE_LIST = [
    { id: "small", name: "Small", inchPerLetter: 3, height: 10 },
    { id: "medium", name: "Medium", inchPerLetter: 4, height: 13 },
    { id: "large", name: "Large", inchPerLetter: 5, height: 15 },
  ];
  const CACHE_PREFIX = "neoniify-preview-v1:";
  const imageCache = new Map();

  const unitValue = (value, fallback) => {
    const number = Number(value);
    if (!Number.isFinite(number)) return fallback;
    return number > 1 ? number / 100 : number;
  };

  const reduceMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const sanitizeText = (value) =>
    String(value || "")
      .replace(/[\u0000-\u001F\u007F]/g, "")
      .replace(/\s+/g, " ")
      .trim();

  const parseConfig = (raw) => {
    if (!raw) return null;
    if (typeof raw === "object") return raw;
    try {
      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  };

  const compactBackgroundUrl = (url) => {
    const raw = String(url || "").trim();
    if (!raw || raw === "featured" || raw === "room") return "";
    try {
      const parsed = new URL(raw, window.location.origin);
      if (parsed.protocol !== "http:" && parsed.protocol !== "https:") return "";
      return `${parsed.origin}${parsed.pathname}`.slice(0, 240);
    } catch (error) {
      if (/^https?:\/\//i.test(raw) || raw.startsWith("//")) return raw.slice(0, 240);
      return "";
    }
  };

  const resolveFont = (config) => {
    const token = String(config.fn || config.f || config.font || "")
      .trim()
      .toLowerCase();
    return (
      FONT_LIST.find(
        (font) =>
          font.id.toLowerCase() === token ||
          font.name.toLowerCase() === token ||
          font.family.toLowerCase() === token
      ) || FONT_LIST[0]
    );
  };

  const resolveColor = (config) => {
    const token = String(config.c || config.color || config.cn || "").trim();
    if (token.startsWith("#") && token.length >= 4) return { name: token, hex: token };
    return (
      COLOR_LIST.find(
        (color) => color.name.toLowerCase() === token.toLowerCase() || color.hex.toLowerCase() === token.toLowerCase()
      ) || COLOR_LIST[0]
    );
  };

  const previewKey = (config) =>
    [
      "n",
      PREVIEW_VERSION,
      config.vid || "",
      config.t || "",
      config.f || "",
      config.c || "",
      config.s || "",
      config.bg || "",
    ].join("|");

  const compactConfig = (config) => ({
    v: PREVIEW_VERSION,
    t: config.t || "",
    f: config.f || "",
    fn: config.fn || "",
    c: config.c || "#ffffff",
    s: config.s || "",
    bg: compactBackgroundUrl(config.bg || config.background || ""),
    g: (() => {
      const glowRaw = Number(config.g || 0.45);
      return glowRaw > 1 ? Math.round(glowRaw) : Math.round(glowRaw * 100);
    })(),
    ty: Math.round(Number(config.ty) > 1 ? Number(config.ty) : Number(config.ty || 0.32) * 100),
    mw: Math.round(Number(config.mw) > 1 ? Number(config.mw) : Number(config.mw || 0.86) * 100),
  });

  const ensureFontsStylesheet = () => {
    if (document.getElementById("neoniify-fonts")) return;
    const link = document.createElement("link");
    link.id = "neoniify-fonts";
    link.rel = "stylesheet";
    link.href = FONT_HREF;
    document.head.appendChild(link);
  };

  const readCache = (key) => {
    try {
      return parseConfig(sessionStorage.getItem(CACHE_PREFIX + key));
    } catch (error) {
      return null;
    }
  };

  const writeCache = (key, config) => {
    try {
      sessionStorage.setItem(CACHE_PREFIX + key, JSON.stringify(compactConfig(config)));
    } catch (error) {
      /* private mode or quota */
    }
  };

  const fitFontSize = (ctx, text, family, maxWidth, maxSize, minSize) => {
    let size = maxSize;
    ctx.font = `${size}px "${family}", cursive`;
    while (size > minSize && ctx.measureText(text).width > maxWidth) {
      size -= 1;
      ctx.font = `${size}px "${family}", cursive`;
    }
    return size;
  };

  const setPreviewLabel = (container, text) => {
    const label = text ? `Custom neon preview of ${text}` : "Custom neon sign preview";
    container.setAttribute("role", "img");
    container.setAttribute("aria-label", label);
    const sr = container.querySelector(".neoniify-preview__label");
    if (sr) sr.textContent = label;
  };

  const resolveTargets = (container) => {
    const cartRoot = container.closest?.(".neoniify-cart-preview");
    if (cartRoot) {
      return {
        root: cartRoot,
        host: cartRoot.querySelector(".neoniify-cart-preview__canvas") || cartRoot,
        isCart: true,
      };
    }
    return { root: container, host: container, isCart: false };
  };

  const ensureBackgroundImage = (root, url) => {
    const src = compactBackgroundUrl(url);
    if (!src) return null;
    let image = root.querySelector(
      "img.neoniify-preview__bg, img.neoniify-preview__fallback, img.neoniify-cart-preview__bg, img.neoniify-cart-preview__fallback"
    );
    if (!image) {
      image = document.createElement("img");
      image.className = root.classList.contains("neoniify-cart-preview")
        ? "neoniify-cart-preview__bg"
        : "neoniify-preview__bg";
      image.alt = "";
      image.setAttribute("aria-hidden", "true");
      root.insertBefore(image, root.firstChild);
    }
    if (image.getAttribute("src") !== src) image.setAttribute("src", src);
    return image;
  };

  const getOrCreateCanvas = (root, host, isCart) => {
    const existing =
      host.querySelector("canvas") ||
      root.querySelector("canvas.neoniify-preview__canvas") ||
      root.querySelector("canvas");
    if (existing) return existing;
    const canvas = document.createElement("canvas");
    canvas.className = "neoniify-preview__canvas";
    canvas.setAttribute("aria-hidden", "true");
    host.appendChild(canvas);
    return canvas;
  };

  const loadBackgroundBitmap = (url) => {
    const src = compactBackgroundUrl(url);
    if (!src) return Promise.resolve(null);
    if (imageCache.has(src)) return imageCache.get(src);
    const pending = new Promise((resolve) => {
      const image = new Image();
      image.decoding = "async";
      image.onload = () => resolve(image);
      image.onerror = () => resolve(null);
      image.src = src;
    });
    imageCache.set(src, pending);
    return pending;
  };

  const drawCoverImage = (ctx, image, width, height) => {
    if (!image || !image.width || !image.height) return false;
    const scale = Math.max(width / image.width, height / image.height);
    const drawWidth = image.width * scale;
    const drawHeight = image.height * scale;
    ctx.drawImage(image, (width - drawWidth) / 2, (height - drawHeight) / 2, drawWidth, drawHeight);
    return true;
  };

  const NeoniifyPreview = {
    fonts: FONT_LIST,
    colors: COLOR_LIST,
    sizes: SIZE_LIST,
    version: PREVIEW_VERSION,
    fontHref: FONT_HREF,
    compactBackgroundUrl,
    ensureFontsStylesheet,

    async render(container, rawConfig) {
      if (!(container instanceof Element)) return false;
      const config = parseConfig(rawConfig);
      if (!config) return false;

      const { root, host, isCart } = resolveTargets(container);
      const canvas = getOrCreateCanvas(root, host, isCart);
      const font = resolveFont(config);
      const colorInfo = resolveColor(config);
      const family = config.fn || font.family;
      const color = colorInfo.hex;
      const text = sanitizeText(config.t || config.text);
      const placeholder = sanitizeText(config.placeholder || "");
      const displayText = text || placeholder;
      const glow = unitValue(config.g, 0.45);
      const background = compactBackgroundUrl(config.bg || config.background || root.getAttribute("data-background") || "");
      const key = previewKey({
        t: displayText,
        f: font.id,
        c: color,
        s: config.s || config.size || "",
        bg: background,
        vid: config.vid || root.getAttribute("data-line-key") || "",
      });

      const rect = root.getBoundingClientRect();
      const laidOut = rect.width >= 40 && rect.height >= 40;
      const fallbackSize = isCart ? 120 : 64;
      const width = Math.max(Math.floor(rect.width) || 0, fallbackSize);
      const height = Math.max(Math.floor(rect.height) || 0, fallbackSize);

      if (!isCart && !laidOut) {
        root.dataset.neoniifyReady = "";
        return false;
      }

      if (
        root.dataset.neoniifyKey === key &&
        (root.dataset.neoniifyReady === "true" || root.getAttribute("data-preview-ready") === "true") &&
        Math.abs(canvas.width / (window.devicePixelRatio || 1) - width) < 2
      ) {
        return true;
      }

      setPreviewLabel(root, displayText);
      ensureBackgroundImage(root, background);

      ensureFontsStylesheet();
      try {
        if (document.fonts?.load && displayText) {
          await document.fonts.load(`48px "${family}"`);
          await document.fonts.ready;
        }
      } catch (error) {
        console.error("Neoniify preview font load failed:", error);
      }

      const backgroundImage = await loadBackgroundBitmap(background);
      const hasPhotoNode = root.querySelector(
        "img.neoniify-preview__bg, img.neoniify-preview__fallback, img.neoniify-cart-preview__bg, img.neoniify-cart-preview__fallback"
      );
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.max(1, Math.floor(width * dpr));
      canvas.height = Math.max(1, Math.floor(height * dpr));
      canvas.style.width = "100%";
      canvas.style.height = "100%";

      const ctx = canvas.getContext("2d");
      if (!ctx) return false;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, width, height);

      const drewPhoto = isCart ? drawCoverImage(ctx, backgroundImage, width, height) : false;
      if (isCart && !drewPhoto && !hasPhotoNode) {
        ctx.fillStyle = "#171717";
        ctx.fillRect(0, 0, width, height);
      }

      if (!displayText) {
        root.dataset.neoniifyReady = "true";
        root.dataset.neoniifyKey = key;
        return true;
      }

      const maxWidth = width * unitValue(config.mw, 0.86);
      const top = height * unitValue(config.ty, 0.32);
      const fontSize = fitFontSize(ctx, displayText, family, maxWidth, Math.min(width * 0.22, height * 0.28), 12);
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillStyle = color;
      ctx.shadowColor = color;
      ctx.shadowBlur = reduceMotion() ? 6 : Math.max(6, fontSize * glow);
      ctx.fillText(displayText, width / 2, top);
      if (!reduceMotion()) {
        ctx.shadowBlur = Math.max(3, fontSize * glow * 0.35);
        ctx.fillText(displayText, width / 2, top);
      }

      root.dataset.neoniifyReady = "true";
      root.dataset.neoniifyKey = key;
      root.classList.add("neoniify-preview--ready");
      writeCache(key, { ...config, t: displayText, f: font.id, fn: family, c: color, bg: background });
      return true;
    },

    hydrate(root) {
      const scope = root && root.querySelectorAll ? root : document;
      ensureFontsStylesheet();
      scope.querySelectorAll("[data-neoniify-preview]").forEach((node) => {
        let config = parseConfig(node.getAttribute("data-neoniify-preview"));
        if (!config) return;
        const cached = readCache(previewKey(config));
        if (cached && cached.t === config.t) config = { ...cached, ...config };
        this.render(node, config);
      });
    },
  };

  window.NeoniifyPreview = NeoniifyPreview;
})();
